export default __webpack_public_path__ + "static/media/tiendita-tacos.6f9a3634.jpeg";